import React, { PureComponent } from "react"
import FileSelector from "js/includes/components/FileSelector"
import FileUpload from "js/state/reducers/scripting/fileUpload"

export default class InstallApplicationFileUpload extends PureComponent {
  state = {
    file: null,
    uploadPercentage: 0,
    fileUploadObject: new FileUpload(),
    isUploading: false,
    uploadFailure: false,
    uploadSucceeded: false,
  }

  onChange = file => {
    if (file) {
      this.setState({
        file,
        uploadPercentage: 0,
        labelMessage: file.name,
        uploadFailure: false,
        uploadSucceeded: false,
      })
    } else {
      this.setState({
        file: "",
        uploadPercentage: 0,
        uploadFailure: false,
        uploadSucceeded: false,
      })
    }
    this.state.fileUploadObject.cancelEvents()
    this.props.onUploadFileChange()
  }

  onFormSubmit = e => {
    e.preventDefault()
    if (this.state.file) {
      this.fileUpload(this.state.file)
    }
  }

  fileUpload = file => {
    this.state.fileUploadObject.upload({
      file,
      fullFileName: file.name,
      onUploadFailure: this.onUploadFailure,
      onUploadSuccess: this.onUploadSuccess,
      onUploadProgress: this.onUploadProgress,
      onUploadStarted: this.onUploadStarted,
      onUploadFinished: this.onUploadFinished,
      onUploadFileChange: this.onUploadFileChange,
    })
  }

  onUploadSuccess = (path, fileName) => {
    this.setState({
      uploadFailure: false,
      uploadSucceeded: true,
    })
    this.props.onUploadSuccess(path, fileName)
  }

  onUploadProgress = uploadPercentage => {
    this.setState({ uploadPercentage })
  }

  onUploadFailure = () => {
    this.setState({
      uploadFailure: true,
      uploadSucceeded: false,
    })
    this.props.onUploadFailure()
  }

  onUploadStarted = () => {
    this.setState({
      uploadFailure: false,
      isUploading: true,
    })
  }

  onUploadFinished = () => {
    this.setState({
      isUploading: false,
    })
  }

  componentWillUnmount() {
    this.state.fileUploadObject.cancelEvents()
  }

  render() {
    return (
      <FileSelector
        accept=".exe, .msi"
        label={this.state.labelMessage}
        onChange={this.onChange}
        onUpload={this.onFormSubmit}
        percentage={this.state.uploadPercentage}
        isUploading={this.state.isUploading}
        uploadFailure={this.state.uploadFailure}
        uploadSucceeded={this.state.uploadSucceeded}
      />
    )
  }
}
